module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$parent.isAdminPage(_vm.$route.path, _vm.$route.name)) ? _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(dashboard)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/dashboard?page=1",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-speedometer"
  }), _vm._v(" Employee Dashboard\r\n                  ")])], 1), _vm._v(" "), (_vm.userinfo.is_approver === 1) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.isActiveMenuGroup(_vm.reports_paths)
    }
  }) : _vm._e(), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(reports/user-tasks)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/time-sheets/approval',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" Time Sheet Approval\r\n                  ")])], 1), _vm._v(" "), (_vm.is_director) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(time-sheets/all)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/time-sheets/all?page=1",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-speedometer"
  }), _vm._v(" All Timesheets\r\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('reports_read') >= 0 && _vm.userinfo.is_approver === 1) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.isActiveMenuGroup(_vm.reports_paths)
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(reports/user-tasks)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/time-sheets-report',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" Aggregated Report\r\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(reports/user-tasks)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/time-sheets-report/detailed-report',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" Detailed Report\r\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(reports/user-tasks)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/time-sheets-report/monthly-pdf-report',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" Monthly PDF Report\r\n                        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('reports_read') >= 0 && _vm.userinfo.is_approver === 1) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.isActiveMenuGroup(_vm.settings_paths)
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(users)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/users?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Users\r\n                      ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(categories)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/categories?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Manage Category\r\n                      ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(contracttype)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/contracttype?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Contract Types\r\n                      ")])], 1)])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v("Time Sheet Reports")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-wrench"
  }), _vm._v("User Management")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41a57726!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 594
// module chunks = 97